import update from 'immutability-helper';
import * as types from './types';

const initialState = {
  showDiagChart: false,
};

const reducerMap = Object.create(null);

reducerMap[types.TOGGLE_DIAG_CHART] = (state, action) => update(state, {
  showDiagChart: {
    $set: action.showDiagChart,
  },
});


const dimensionContainer = (state = initialState, action) => (
  reducerMap[action.type]
    ? reducerMap[action.type](state, action)
    : state
);

export default dimensionContainer;
